import React from 'react';
import { useMsal } from '@azure/msal-react';
import { BrowserAuthError } from '@azure/msal-browser';
import { loginRequest } from './authConfig';
import { Button, message } from 'antd';
import { LoginOutlined } from '@ant-design/icons';

/** Primary sign-in button; triggers an MSAL popup or redirect login. */

interface SignInButtonProps {
  loginType?: 'popup' | 'redirect';
}

export const SignInButton = ({ loginType = 'redirect' }: SignInButtonProps) => {
  const { instance } = useMsal();

  const handleLogin = () => {
    const request = { ...loginRequest, redirectUri: window.location.origin };
    const login =
      loginType === 'popup'
        ? instance.loginPopup(request)
        : instance.loginRedirect(request);
    login.catch((e: unknown) => {
      // Dismissing the popup isn't a failure worth a red toast.
      if (e instanceof BrowserAuthError && e.errorCode === 'user_cancelled') {
        return;
      }
      void message.error('Sign-in failed. Please try again.');
    });
  };

  return (
    <Button
      icon={<LoginOutlined />}
      onClick={handleLogin}
      size="large"
      type="primary"
    >
      Sign In
    </Button>
  );
};
